import Vue from 'vue';
import { BfModal, BfButton, BfDialog, BfTextInput } from 'src/components/Butterfly';
import { Form, Field } from 'components/forms';
import 'components/forms/rules/required';
import 'components/forms/rules/between';
export default Vue.extend({
    name: 'Paginator',
    components: { BfTextInput, BfDialog, BfModal, BfButton, Form, Field },
    props: {
        startIndex: { type: Number, required: true },
        overallFinalIndex: { type: Number, default: null },
        perPage: { type: Number, required: true },
    },
    data() {
        return {
            modalVisible: false,
            errors: [],
        };
    },
    computed: {
        initialValues() {
            return {
                // convert startIndex to page number
                // protect against negative, undefined, and null numbers
                page: `${Math.floor(Math.max(this.startIndex / this.perPage, 0) + 1) || 1}`
            };
        },
        endIndex() {
            return Math.min(this.startIndex + this.perPage - 1, this.overallFinalIndex);
        },
        numberOfPages() {
            return Math.ceil(this.overallFinalIndex / this.perPage);
        }
    },
    methods: {
        showModal() {
            this.modalVisible = true;
            const formRef = this.$refs['form'];
            formRef?.resetForm();
        },
        cancelModal() {
            this.modalVisible = false;
        },
        submitModal({ page }) {
            this.modalVisible = false;
            const goToPage = parseInt(page, 10) || 1;
            const newStartIndex = Math.max((goToPage - 1) * this.perPage + 1, 1);
            this.$emit('page-changed', newStartIndex);
        }
    }
});
